import { render, staticRenderFns } from "./base-navigation-menu.vue?vue&type=template&id=70e67c72&scoped=true"
import script from "./base-navigation-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./base-navigation-menu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-navigation-menu.vue?vue&type=style&index=0&id=70e67c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e67c72",
  null
  
)

export default component.exports